export const SORT_BY_CONSTANTS = [
    "priceASC",
    "priceDESC",
    "nameASC",
    "nameDESC",
    "producerNameASC",
    "producerNameDESC"
];
